/*
 * ByLamari: Produktseite des übertragenen Hydrogen-Neubaus (Theme-Kopie B, 25.10.2026), Teil 1.
 * Kern (Variante, Galerie-Reihenfolge, Preise) steht in snippets/bl-pdp-start (BL.pdp). Hier:
 *  - Galerie: Bilder 2, 3, … erst nach dem Laden oder beim Wischen, Balken und „1/7“ (routes/product.tsx Galerie)
 *  - Farbwahl ohne Neuladen (FarbWahl), Kaufen mit BL.inDenWarenkorb (KaufFormular)
 *  - „Kaufe 3, zahl 2“ bzw. „Passt dazu“ aus Shopifys Empfehlungen (Dazu), fehlende Ringe in der Farbe aus den Ringen
 *  - Daten für Kombinieren und Der Look: BL.pdp.daten('ringe' | 'alle') über sections/bl-pdp-daten
 */
(function () {
  var BL = (window.BL = window.BL || {});
  var P = BL.pdp;
  if (!P) return;
  var d = P.d, q = P.q, qa = P.qa, esc = P.esc, geld = P.geld;

  /* ── Daten (Section Rendering API) ─────────────────────────────────── */
  var cache = {};
  P.daten = function (art) {
    var url = '/collections/' + (art === 'ringe' ? 'ringe' : 'all') + '?section_id=bl-pdp-daten';
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('daten'); return r.text(); })
        .then(function (t) {
          var m = /<script[^>]*data-bl-pdp-daten[^>]*>([\s\S]*?)<\/script>/.exec(t);
          return JSON.parse(m[1]);
        })
        .catch(function () { delete cache[url]; return null; });
    }
    return cache[url];
  };

  /* lib/collection.ts farbBilderAus: Farbe steht im Dateinamen („…_-_Silber_54.png“), einige Fotos fest zugeordnet */
  var SILBER = ',img-2702.png,841aa9f6-1a23-4404-b286-a4fe4f26097f.png,96a8a894-323c-4db7-8a98-517b5a4c12ea.png,0f503c43-41ca-4ff9-9bb3-791f3b654fba.png,fc786225-26a0-4b22-90b0-e4300b875967.png,dd58bac0-4997-4702-bb7e-e4d55a4b7187.png,499ffa33-e357-41b2-8847-a08852eefeac.png,9f886cab-e391-4ff6-a669-e98109462ce9.png,830e5b71-9dda-49d9-9574-2e02cb118a35.png,bad0934e-5528-4ab9-8a34-8e9697703085.png,ecd3db78-feba-485b-8e07-ef9562e68d42.png,09025bc8-89a1-40ec-b0c2-5a98a22fe4ef.png,42001caf-5b1a-406e-a9fc-1222998c0b03.png,1fb3e8ad-a352-42bb-bc7e-ae12c74279be.png,85bc98e8-14f1-4d13-a6f9-ce83f1ad59b3.png,bad932ec-4fce-4f4c-a809-13e5fc81ce6f.png,09e422ec-54b0-4683-9343-d6c1bbb3d184.png,54a8acf3-c3f7-4917-8202-ada188a845b9.png,d6fa0e2a-1e5b-4c10-920e-f49693fc5804.png,';
  P.farbBilder = function (urls) {
    var aus = {};
    urls.forEach(function (u) {
      var datei = decodeURIComponent((u.split('/').pop() || '').split('?')[0]);
      var t = /_-_(Gold|Silber|Bicolor)[_.]/i.exec(datei);
      var f = t ? t[1].toLowerCase() : SILBER.indexOf(',' + datei.toLowerCase() + ',') > -1 ? 'silber' : datei.toLowerCase() === '77202404-39bb-4cfa-b5d8-a4e8bfc9f70a.png' ? 'mix' : null;
      if (f && !aus[f]) aus[f] = u;
    });
    return aus;
  };

  /* components/SchnellKauf.tsx: Plus legt die oben gewählte Farbe ein, sonst die erste lieferbare Variante */
  function farbeVon(v) {
    var o = (v.selectedOptions || []).filter(function (x) { return x.name.toLowerCase() === 'farbe'; })[0];
    return o ? o.value : null;
  }
  P.farbeVon = farbeVon;
  P.schnell = function (titel, varianten, verfuegbar, farbe) {
    if (!verfuegbar) return '';
    var da = varianten.filter(function (v) { return v.availableForSale; });
    var v = null;
    if (farbe) v = da.filter(function (x) { return (farbeVon(x) || '').toLowerCase() === farbe.toLowerCase(); })[0] || null;
    v = v || da[0];
    if (!v) return '';
    var name = varianten.length > 1 ? farbeVon(v) : null;
    var label = name ? titel + ' in ' + name + ' in den Warenkorb legen' : titel + ' in den Warenkorb legen';
    var meldung = name ? titel + ' in ' + name + ' liegt im Warenkorb.' : titel + ' liegt im Warenkorb.';
    return '<div class="bl-schnellkauf"><form action="/cart/add" method="post" class="bl-schnellkauf__form" data-bl-schnellkauf data-meldung="' + esc(meldung) + '">' +
      '<input type="hidden" name="id" value="' + v.id + '"><input type="hidden" name="quantity" value="1">' +
      '<button type="submit" name="add" class="bl-plus" aria-label="' + esc(label) + '"><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
      '</form><span class="sr-only" aria-live="polite" data-bl-meldung></span></div>';
  };

  /* Warenkorb-Zustand für Gratis-Ring und Kombinieren */
  document.addEventListener('bl:gratis', function (e) { P.max = e.detail.max; });
  document.addEventListener('bl:warenkorb', function (e) {
    var n = 0;
    (e.detail.cart.items || []).forEach(function (i) { if (i.variant_id !== 53831940145418 && i.product_type === 'Ring') n += i.quantity; });
    P.ringe = n;
  });

  /* ── Galerie ───────────────────────────────────────────────────────── */
  var g = q('[data-bl-galerie]');
  if (g) {
    var spur = q('.bl-pdp-galerie__spur', g);
    var weitere = function () {
      if (P.weitere) return;
      P.weitere = true;
      P.galerie(P.v, true);
    };
    ['pointerdown', 'touchstart', 'focus'].forEach(function (n) { spur.addEventListener(n, weitere, { passive: true }); });
    spur.addEventListener('scroll', function () {
      weitere();
      if (spur.clientWidth > 0) {
        var i = Math.round(spur.scrollLeft / spur.clientWidth);
        if (i !== P.aktiv) P.zeigeAktiv(i);
      }
    }, { passive: true });
    var los = function () { setTimeout(weitere, 1500); };
    if (document.readyState === 'complete') los(); else window.addEventListener('load', los, { once: true });
  }

  /* ── Farbwahl ──────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[data-bl-wert]');
    if (!a || e.button !== 0 || e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var oi = +a.getAttribute('data-bl-option'), wert = a.getAttribute('data-bl-wert');
    var jetzt = P.v ? P.v.o : [];
    var v = null;
    d.v.forEach(function (x) {
      if (v || x.o[oi] !== wert) return;
      if (x.o.every(function (o, i) { return i === oi || o === jetzt[i]; })) v = x;
    });
    if (!v) d.v.forEach(function (x) { if (!v && x.o[oi] === wert) v = x; });
    if (v && v !== P.v) P.wahl(v);
  });

  /* ── Kaufen ────────────────────────────────────────────────────────── */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('[data-bl-pdp-form]') || !BL.inDenWarenkorb) return;
    e.preventDefault();
    var box = f.closest('[data-bl-kauf]'), k = f.querySelector('button'), fehler = q('[data-bl-kauf-fehler]', box);
    if (k.disabled) return;
    k.disabled = true;
    k.setAttribute('aria-busy', 'true');
    fehler.hidden = true;
    BL.inDenWarenkorb([{ id: parseInt(f.querySelector('[name="id"]').value, 10), quantity: 1 }])
      .catch(function (err) {
        fehler.innerHTML = '<p>' + esc((err && err.message) || 'Das hat leider nicht geklappt. Bitte versuch es gleich noch einmal.') + '</p>';
        fehler.hidden = false;
      })
      .then(function () {
        k.disabled = !(P.v && P.v.a);
        k.removeAttribute('aria-busy');
      });
  });

  /* ── Kaufe 3, zahl 2 / Passt dazu ──────────────────────────────────── */
  var halter = q('[data-bl-pdp-dazu]');
  var empfohlen = null, ringe = null, ringeLaden = false;
  function karteAus(p) {
    var namen = (p.options || []).map(function (o) { return o.name; });
    return {
      handle: p.handle, title: p.title, istRing: p.type === 'Ring', verfuegbar: p.available,
      bild: p.featured_image || null,
      farbBilder: P.farbBilder(p.images || []),
      preis: p.price_min,
      varianten: (p.variants || []).map(function (v) {
        return { id: v.id, availableForSale: v.available, selectedOptions: (v.options || []).map(function (w, i) { return { name: namen[i], value: w }; }) };
      })
    };
  }
  P.karteAusDaten = function (r) {
    return {
      handle: r.h, title: r.t, istRing: true, verfuegbar: true, bild: r.f, farbBilder: r.fb || {},
      preis: r.v[0] ? r.v[0][2] : 0,
      varianten: r.v.map(function (v) { return { id: v[0], availableForSale: true, selectedOptions: v[3] ? [{ name: 'Farbe', value: v[3] }] : [] }; })
    };
  };
  function hatFarbe(k, f) {
    return k.varianten.some(function (v) { return v.availableForSale && (farbeVon(v) || '').toLowerCase() === f.toLowerCase(); });
  }
  function dazuZeigen() {
    if (!halter || !empfohlen) return;
    var farbe = P.farbe(P.v);
    var inFarbe = farbe ? empfohlen.filter(function (k) { return hatFarbe(k, farbe); }).length : 3;
    var ergaenzen = d.ring && !!farbe && inFarbe < 3;
    if (ergaenzen && !ringe && !ringeLaden) {
      ringeLaden = true;
      P.daten('ringe').then(function (r) {
        ringeLaden = false;
        if (r) { ringe = r.map(P.karteAusDaten); dazuZeigen(); }
      });
    }
    var gesehen = {}; gesehen[d.h] = 1;
    var alle = empfohlen.concat(ergaenzen && ringe ? ringe : []).filter(function (k) {
      if (gesehen[k.handle]) return false;
      gesehen[k.handle] = 1;
      return true;
    });
    var e = alle.map(function (k) { return { k: k, inFarbe: !!farbe && hatFarbe(k, farbe) }; });
    var auswahl = e.filter(function (x) { return x.inFarbe; })
      .concat(e.filter(function (x) { return !x.inFarbe && empfohlen.indexOf(x.k) > -1; }))
      .slice(0, 3);
    if (!auswahl.length) { halter.hidden = true; halter.innerHTML = ''; return; }
    var html = '<section class="bl-pdp-dazu" id="dazu" aria-labelledby="dazu-titel"><h2 id="dazu-titel">' + (d.ring ? 'Kaufe 3, zahl 2' : 'Passt dazu') + '</h2>' +
      (d.ring ? '<p>Nimm 2 Ringe dazu, einer davon ist gratis.</p>' : '') + '<ul role="list" class="bl-pdp-dazu__liste">' +
      auswahl.map(function (x) {
        var k = x.k;
        var bild = (x.inFarbe && farbe ? k.farbBilder[farbe.toLowerCase()] : null) || k.bild;
        var zeige = x.inFarbe ? farbe : farbeVon(k.varianten[0] || {});
        var ziel = x.inFarbe && farbe && k.varianten.length > 1 ? '/products/' + k.handle + '?Farbe=' + encodeURIComponent(farbe) : '/products/' + k.handle;
        var preis = d.ring && k.istRing ? P.gp(k.preis, true, k.verfuegbar, geld(k.preis)) : geld(k.preis);
        return '<li class="bl-pdp-dazu__karte"><a href="' + esc(ziel) + '" class="bl-pdp-dazu__link"><span class="bl-pdp-dazu__bild">' +
          (bild ? '<img src="' + esc(P.bildUrl(bild, 300)) + '" srcset="' + esc(P.quadrat(bild, 200)) + '" alt="" width="300" height="300" loading="lazy" decoding="async">' : '') +
          '</span><span class="bl-pdp-dazu__name">' + esc(k.title) + '</span><span class="bl-pdp-dazu__meta">' +
          (zeige ? '<span class="bl-pdp-dazu__farbe">' + esc(zeige) + '</span>' : '') + preis + '</span></a>' +
          P.schnell(k.title, k.varianten, k.verfuegbar, x.inFarbe ? farbe : null) + '</li>';
      }).join('') + '</ul></section>';
    halter.innerHTML = html;
    halter.hidden = false;
    P.gpMerken(halter);
  }
  if (halter) {
    var rec = function (intent) {
      return fetch('/recommendations/products.json?product_id=' + d.pid + '&intent=' + intent + '&limit=10')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; })
        .catch(function () { return []; });
    };
    Promise.all([rec('complementary'), rec('related')]).then(function (l) {
      var gesehen = {};
      var k = l[0].concat(l[1]).filter(function (p) {
        if (p.handle === d.h || !p.available || gesehen[p.handle]) return false;
        gesehen[p.handle] = 1;
        return true;
      });
      if (d.ring) k = k.filter(function (p) { return p.type === 'Ring'; });
      empfohlen = k.slice(0, 9).map(karteAus);
      dazuZeigen();
    });
    document.addEventListener('bl:pdp-variante', dazuZeigen);
  }
})();